import styled from 'styled-components';

import { mediaTopBarVisible, mediaTopBarHidden } from '@xing-com/layout-tokens';
import { spaceL, spaceXXL, spaceS } from '@xing-com/tokens';

export const StyledProductsMenuWrapper = styled.div`
  @media (max-width: 1112px) {
    display: none;
  }
`;

const StyledActionsContainer = styled.div`
  display: flex;
  align-items: center;

  @media ${mediaTopBarHidden} {
    gap: ${spaceS};
  }

  @media (min-width: 1428px) {
    gap: ${spaceL};
  }

  @media (min-width: 1572px) {
    gap: ${spaceXXL};
  }
`;

export const ActionButtonSpace = styled.div`
  padding: ${spaceS};
`;

export const BoneyardWithDiscountContainer = styled(ActionButtonSpace)`
  position: relative;
`;

export const StyledOnlyOnBigScreenContainer = styled(StyledActionsContainer)`
  @media ${mediaTopBarVisible} {
    display: none;
  }
`;

export const StyledOuterActionsContainer = styled(StyledActionsContainer)`
  margin-right: calc(-1 * ${spaceS});
`;
